import styled from '@emotion/styled'

import type { FC } from 'react'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import TestimonialTemplate from '@segment/templates/Testimonial'

const Testimonial: FC = () => {
  return (
    <Wrapper>
      <StyedSectionBase variant="noCopy">
        <Section.Contents>
          <TestimonialTemplate variant="extended" company="craft-jack" />
        </Section.Contents>
      </StyedSectionBase>
    </Wrapper>
  )
}

export default Testimonial

const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.palette.twilio.gray[10]};
`

const StyedSectionBase = styled(SectionBase)`
  ${({ theme }) => theme.breakpoints.up(`xl`)} {
    padding-left: 80px;
    padding-right: 80px;
  }
`
